import { render, staticRenderFns } from "./DinamicClass.vue?vue&type=template&id=012bfd1c&scoped=true"
import script from "./DinamicClass.vue?vue&type=script&lang=js"
export * from "./DinamicClass.vue?vue&type=script&lang=js"
import style0 from "./DinamicClass.vue?vue&type=style&index=0&id=012bfd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012bfd1c",
  null
  
)

export default component.exports